import React from 'react'
import styled from '@emotion/styled'
import { prop } from 'ramda'
import { LIST, DASH_VIEW } from 'utils/constants'
import strings from 'utils/strings'
import { makeComponentMetaSelector } from 'selectors/navigator'
import { setSelectedIdWithDrawerAndMeta } from 'actions/navigator'
import {
  getDashMeta,
  getDashLocations,
  getIsUnassignedComponent,
} from 'selectors/dash'
import { useMakeSelector, useSelector } from 'hooks/redux'
import { Button, Paragraph } from 'components/patterns'
import { SLEEPER_PANEL_LOCATION_ID } from 'components/SwitchAndGauge/definitions/dashConstants'
import { useDispatch } from 'react-redux'

const Breadcrumb = () => {
  const dispatch = useDispatch()
  const locations = useSelector(getDashLocations)
  const meta = useSelector(getDashMeta)

  const { dash, overhead, sleeper } = meta

  const { id: drawerId } = useMakeSelector(makeComponentMetaSelector, {
    id: DASH_VIEW,
  })
  const isUnassignedComponent = useSelector(getIsUnassignedComponent, {
    key: drawerId,
  })

  const handleBreadcrumbClick = (id = '') => {
    dispatch(
      setSelectedIdWithDrawerAndMeta(DASH_VIEW, {
        view: LIST,
        id,
      })
    )
  }

  const allMeta = {
    ...dash,
    ...(overhead && overhead),
    ...(sleeper && {
      [SLEEPER_PANEL_LOCATION_ID]: sleeper[SLEEPER_PANEL_LOCATION_ID],
    }),
  }

  const isPanelPart = locations[drawerId]
  const panelId =
    prop('id', allMeta[drawerId]) || prop('panel', locations[drawerId])

  const panelLabel = prop('label', allMeta[panelId])

  const showLinkedAllPanels = panelLabel || isUnassignedComponent

  return (
    <StyledBreadcrumb>
      {showLinkedAllPanels ? (
        <Button size="small" link onClick={() => handleBreadcrumbClick()}>
          {strings.all_panels}
        </Button>
      ) : (
        <Paragraph size="small">{strings.all_panels}</Paragraph>
      )}
      {isPanelPart ? (
        <>
          &nbsp; / &nbsp;
          <Button
            size="small"
            link
            onClick={() => handleBreadcrumbClick(panelId)}
          >
            {panelLabel}
          </Button>
        </>
      ) : (
        <>
          {panelLabel && (
            <>
              &nbsp; / &nbsp;
              <Paragraph style={{ display: 'inline' }} size="small">
                {panelLabel}
              </Paragraph>
            </>
          )}
        </>
      )}
    </StyledBreadcrumb>
  )
}

Breadcrumb.propTypes = {}

export default Breadcrumb

export const StyledBreadcrumb = styled.div((props) => {
  const { btnDisabledBorderColor } = props.theme.color

  return `
    border-bottom: 1px solid ${btnDisabledBorderColor};
    padding-bottom: 2%;
  `
})
